import { OnboardingStep } from '../../OnboardingStep/OnboardingStep'
import { getStepStatus } from '../utils'

interface RateMealsStepProps {
  completed: boolean
  enabled: boolean
}

export function RateMealsStep({
  completed,
  enabled
}: Readonly<RateMealsStepProps>) {
  const handleRateMeals = () => {
    // Pending logic implementation
  }

  return (
    <OnboardingStep
      title="Rate Your Meals"
      description="We’d love to hear about your first order! Please take a moment to rate your meals and share your feedback. Your input helps us tailor better recommendations just for you."
      status={getStepStatus(completed, enabled)}
      icon="star"
      tag={enabled ? undefined : 'Available after your first delivery'}
      action={{
        label: 'Rate Meals',
        onClick: handleRateMeals
      }}
    />
  )
}
